import React, { useMemo } from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Imagem from 'Component/Imagem';
import Usuario from 'Interface/Usuarios';
import { useEditarUsuarioMutation } from 'Service';

interface Props {
  dados: Usuario;
  acoes?: boolean;
}

const Lista = ({ dados, acoes = true }: Props): React.ReactElement => {
  const toast = useToast();
  const [editarUsuario] = useEditarUsuarioMutation();

  const remover = async (): Promise<void> => {
    try {
      await editarUsuario({ id: dados.id, ativo: false }).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  const inativo = useMemo(() => {
    let inativo = true;

    dados.vinculos_empregaticios?.map((vinculo) => {
      if (vinculo.status == 1 || vinculo.status == 2) {
        inativo = false;
      }
    });

    return inativo;
  }, [dados]);

  return (
    <div
      key={dados.nome}
      className="d-flex border-bottom align-items-center py-2 px-3"
    >
      <Link to={`/usuarios/editar/${dados.id}`}>
        <Imagem
          src={dados.imagem}
          alt={dados.nome}
          className="rounded-circle object-fit-cover"
          width="80"
          height="80"
        />
      </Link>
      <div className="ms-4 fs-4">
        <Link
          to={`/usuarios/editar/${dados.id}`}
          className={`text-decoration-none ${inativo ? 'text-danger' : ''}`}
        >
          {dados.nome}
        </Link>
        <small className="d-block fs-6 text-muted">
          {dados.vinculos_empregaticios
            ?.map((vinculo) => vinculo.status == 1 ? vinculo.empresa?.razao_social : null)
            .filter(vinculo => vinculo)
            .join(',').cortar(40) || 'Sem vinculo empregatício'}
        </small>
      </div>
      <BrowserView className="d-flex flex-grow-1 align-items-center justify-content-end">
        <div className="ms-5 fs-5 text-end">
          {dados.cpf}
          <small className="d-block fs-6 text-muted">CPF</small>
        </div>
        <div className="ms-5 fs-5 text-end">
          {dados.criado.data().toLocaleString()}
          <small className="d-block fs-6 text-muted">Criado em</small>
        </div>
        <div className="ms-5 fs-5 text-end">
          <span className="badge bg-primary">{dados.permissao}</span>
          {acoes && (
            <Botao
              icone="trash"
              tema="danger"
              className="ms-5"
              confirmacao="Você tem certeza que deseja remover esse usuário? Essa ação é irreversivel."
              onClick={remover}
            />
          )}
        </div>
      </BrowserView>
    </div>
  );
};

export default Lista;
